// import React, { forwardRef } from 'react'
// import ReactQuill from 'react-quill'
// import 'react-quill/dist/quill.snow.css'

// const RichTextEditor = forwardRef((props, ref) => {

// 	return (
// 		<div className="rich-text-editor">
// 			<ReactQuill ref={ref} {...props}  />
// 		</div>
// 	)
// })

// export default RichTextEditor

import React, { forwardRef } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const fontSize = Array.from({ length: 98 }, (_, i) => `${i + 1}px`);
const Size = Quill.import('attributors/style/size');
Size.whitelist = fontSize;
Quill.register(Size, true);

const RichTextEditor = forwardRef((props, ref) => {
  const modules = {
  toolbar: [
    [{ font: [] }],                 
    [{ size: fontSize }],        
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    // [{ script: 'sub' }, { script: 'super' }],
    [{ direction: 'rtl' }, { align: [] }],
    ['link'],    
  ],
  };

  const formats = [
    'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script', 'header', 'list', 'bullet', 'indent',
    'direction', 'align',
    'blockquote', 'code-block',
    'link', 'image', 'video',
  ];

  return (
    <div className="rich-text-editor w-full">
      <style>{`
        /* Show only numbers in font size dropdown */
        .ql-snow .ql-picker.ql-size .ql-picker-label::before,
        .ql-snow .ql-picker.ql-size .ql-picker-item::before {
          content: attr(data-value) !important;
        }
        /* Make font size dropdown scrollable */
        .ql-snow .ql-picker.ql-size .ql-picker-options {
          max-height: 200px; /* adjust height as needed */
          overflow-y: auto;
        }
      `}</style>
      <ReactQuill
        ref={ref}
        modules={modules}
        formats={formats}
        theme="snow"
        className="min-h-[300px] bg-white text-gray-900"
        {...props}
      />
    </div>
  );
});

export default RichTextEditor;